import { render, staticRenderFns } from "./AreaPromoterMission.vue?vue&type=template&id=fa509eec&scoped=true"
import script from "./AreaPromoterMission.vue?vue&type=script&lang=js"
export * from "./AreaPromoterMission.vue?vue&type=script&lang=js"
import style0 from "./AreaPromoterMission.vue?vue&type=style&index=0&id=fa509eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa509eec",
  null
  
)

export default component.exports